import FormattedMessage from 'I18n/components/FormattedMessage';
import { getTypeAction, UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function ApprovalEmptyStateI18nTitle() {
  const {
    meta
  } = useApprovalContext();
  const {
    approvalAction,
    approvalType
  } = meta;
  const typeAction = getTypeAction(approvalType, approvalAction);
  switch (typeAction) {
    case 'MARKETING_EMAIL-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.MARKETING_EMAIL-PUBLISH.title"
        });
      }
    case 'LANDING_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.LANDING_PAGE-PUBLISH.title"
        });
      }
    case 'SITE_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.SITE_PAGE-PUBLISH.title"
        });
      }
    case 'BLOG_POST-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.BLOG_POST-PUBLISH.title"
        });
      }
    case 'DEAL-MOVE_STAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.DEAL-MOVE_STAGE.title"
        });
      }
    case 'KNOWLEDGE_ARTICLE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.KNOWLEDGE_ARTICLE-PUBLISH.title"
        });
      }
    default:
      throw new UnreachableI18nCaseError(typeAction);
  }
}
export function ApprovalEmptyStateI18nFirstSection() {
  const {
    meta
  } = useApprovalContext();
  const {
    approvalAction,
    approvalType
  } = meta;
  const typeAction = getTypeAction(approvalType, approvalAction);
  switch (typeAction) {
    case 'MARKETING_EMAIL-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.MARKETING_EMAIL-PUBLISH.firstSection"
        });
      }
    case 'LANDING_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.LANDING_PAGE-PUBLISH.firstSection"
        });
      }
    case 'SITE_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.SITE_PAGE-PUBLISH.firstSection"
        });
      }
    case 'BLOG_POST-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.BLOG_POST-PUBLISH.firstSection"
        });
      }
    case 'DEAL-MOVE_STAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.DEAL-MOVE_STAGE.firstSection"
        });
      }
    case 'KNOWLEDGE_ARTICLE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.KNOWLEDGE_ARTICLE-PUBLISH.firstSection"
        });
      }
    default:
      throw new UnreachableI18nCaseError(typeAction);
  }
}
export function ApprovalEmptyStateI18nSecondSection() {
  const {
    meta
  } = useApprovalContext();
  const {
    approvalAction,
    approvalType
  } = meta;
  const typeAction = getTypeAction(approvalType, approvalAction);
  switch (typeAction) {
    case 'MARKETING_EMAIL-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.MARKETING_EMAIL-PUBLISH.secondSection"
        });
      }
    case 'LANDING_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.LANDING_PAGE-PUBLISH.secondSection"
        });
      }
    case 'SITE_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.SITE_PAGE-PUBLISH.secondSection"
        });
      }
    case 'BLOG_POST-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.BLOG_POST-PUBLISH.secondSection"
        });
      }
    case 'DEAL-MOVE_STAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.DEAL-MOVE_STAGE.secondSection"
        });
      }
    case 'KNOWLEDGE_ARTICLE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEmptyState.KNOWLEDGE_ARTICLE-PUBLISH.secondSection"
        });
      }
    default:
      throw new UnreachableI18nCaseError(typeAction);
  }
}